import { _ as __read } from '../../../../_tslib-7a01aab4.js';
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import '../../../core/enums/GameSpecificTypes.js';
import '../../../core/enums/MaxPayoutDataTypes.js';
import '../../../core/enums/Chat.js';
import '../../../core/enums/GameModes.js';
import '../../../core/enums/IconTypes.js';
import '../../../core/enums/BetStatus.js';
import '../../../core/enums/PopupTypes.js';
import '../../../core/enums/ApiVersion.js';
import '../../../core/enums/RoundStatus.js';
import '../../../core/enums/FreeBetsStatus.js';
import '../../../core/enums/SocketEvents.js';
import '../../../core/enums/TranslationKeys.js';
import '../../../core/enums/TimeoutMaxValue.js';
import '../../../core/enums/ApiServiceTypes.js';
import '../../../core/enums/EnvironmentTypes.js';
import '../../../core/enums/DefaultQueryValues.js';
import { FreeBetWinningType } from '../../../core/enums/FreeBetWinningType.js';
import '../../../core/enums/DefaultQueryParams.js';
import '../../../core/enums/BetHistoryFilterTypes.js';
import '../../../core/enums/GameThemeTypes.js';
import '../../../core/enums/RequestStatus.js';
import '../../../core/enums/FetchDefaultPaths.js';
import '../../../core/enums/ResponseCodes.js';
import { a2 as betDataStore, D as userInfoStore, a1 as doBetStore, $ as gameConfigStore } from '../../../../validateBalanceOnBet-af4f4a9b.js';
import '../../../core/store/chatStore.js';
import '../../../core/store/wageringStore.js';
import '../../../core/store/roundInfoStore.js';
import '../../../core/store/userCountStore.js';
import '../../../core/store/gameResultStore.js';
import '../../../core/store/resultHashStore.js';
import '../../../core/store/userWinBetsStore.js';
import '../../../core/store/notificationStore.js';
import '../../../core/store/selectedResultInfoStore.js';
import '../../../core/store/forCrashGame/inputValidationStore.js';
import '../../../core/store/forCrashGame/totalBetStore.js';
import { oddStore } from '../../../core/store/forCrashGame/resultReportStore.js';
import '../../../core/store/forCrashGame/gameStore.js';
import { getAmountWithCurrency } from '../../../core/helpers/getAmountWithCurrency.js';
import '../../../core/services/liveConnection/types.js';
import 'axios';
import '../../../core/services/sound/types.js';
import '../../../core/services/sound/SoundService.js';
import '../../../core/services/sound/defaultSounds.js';
import '../../../core/services/api/types.js';
import '../../../core/services/ApiServices.js';
import '../../../../momentFormat-e9197995.js';
import '../../../core/polyfill.js';
import 'mobx';
import '../../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../../core/enums/BogLineGameConfig.js';
import '../../../core/helpers/parseQuery.js';
import '../../../core/enums/StatisticsSortingTypes.js';
import '../../../core/services/api/BaseApiService.js';
import '../../../core/helpers/deepCopy.js';
import '../../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../../table-line/t_types/enums/PopupTypes.js';
import '../../../core/helpers/formatDate.js';
import '../../../core/helpers/isMobile.js';
import '../../../core/enums/bogGameNames.js';
import '../../../core/helpers/updateHalfBets.js';
import '../../../core/enums/Currencies.js';
import 'howler';
import '../../../../_commonjsHelpers-17aad09c.js';

var AccumulatedPossibleWin = observer(function (_a) {
    var sectionIndex = _a.sectionIndex;
    var betAmount = betDataStore.betsSectionsData[sectionIndex].betAmount;
    var _b = __read(useState(betAmount), 2), localWinAmount = _b[0], setLocalWinAmount = _b[1];
    var oddData = oddStore.oddData, isMaxWin = oddStore.isMaxWin, setIsMaxWin = oddStore.setIsMaxWin;
    var precision = userInfoStore.precision;
    var _c = doBetStore.doBetSectionsData[sectionIndex], currentFreeBetMaxPayout = _c.currentFreeBetMaxPayout, currentMaxWin = _c.currentMaxWin, freeBetType = _c.freeBetType, isHalfCashOuted = _c.isHalfCashOuted;
    var amount = isHalfCashOuted ? +betAmount / 2 : +betAmount;
    var currentWinAmount = freeBetType === FreeBetWinningType.Win ? amount * oddData - amount : amount * oddData;
    var maxWin = gameConfigStore.limits.maxWin;
    var maxWinAmount = currentFreeBetMaxPayout || maxWin;
    var maxWinLimit = currentMaxWin || maxWinAmount;
    useEffect(function () {
        if (currentWinAmount > maxWinLimit) {
            // if (isMaxWin[index] && gameStore.showPopUpsWhitData.popUpIndex !== popUpsIndex.win) {
            //   gameStore.setShowPopUpsWhitIndex(popUpsIndex.maxWinPopUp, gameConfigStore.limits.maxWin);
            // }
            if (localWinAmount < maxWinLimit) {
                setLocalWinAmount(maxWinLimit);
            }
            if (!isMaxWin[sectionIndex] && !currentFreeBetMaxPayout) {
                setIsMaxWin(true, sectionIndex);
            }
        }
        else {
            setLocalWinAmount(currentWinAmount);
        }
    }, [oddData]);
    return (React.createElement("span", { className: 'bet-button-amount' }, localWinAmount > 0 &&
        getAmountWithCurrency({
            amount: (+localWinAmount).toFixed(+precision), // core toFixed
        })));
});

export { AccumulatedPossibleWin };
